import { render } from "./ny-geo-locations-form.vue?vue&type=template&id=4548ee92&scoped=true"
import script from "./ny-geo-locations-form.vue?vue&type=script&lang=js"
export * from "./ny-geo-locations-form.vue?vue&type=script&lang=js"

import "./ny-geo-locations-form.vue?vue&type=style&index=0&id=4548ee92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4548ee92"]])

export default __exports__